module.exports = __webpack_public_path__ + "Flag-480.5b5dee765d62a783d265c2f3c36a7180.svg";